export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block border border-[#8B4513]/30 text-[#8B4513] text-xs uppercase tracking-[0.2em] px-4 py-2 rounded-full mb-6">
              關於我們
            </span>
            <h3 className="text-5xl font-black text-[#1a1a1a] leading-tight tracking-tight mb-6">
              堅持品質<br />
              <span className="text-[#8B4513]">從產地到餐桌</span>
            </h3>
            <p className="text-gray-500 text-base leading-relaxed mb-5">
              鮮肉本舖深耕台灣優質肉品市場超過 10 年，與在地農場及國際優質供應商合作，嚴格把關每一批肉品的來源、飼養方式及衛生標準。
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              我們相信，好的食材是美味料理的基礎。每一塊肉品都經過專業分切、真空包裝，確保新鮮度與品質，讓您在家也能享受餐廳級的美味體驗。
            </p>
            <div className="flex items-center space-x-10">
              <div>
                <p className="text-4xl font-black text-[#8B4513]">10+</p>
                <p className="text-gray-400 text-xs uppercase tracking-wide mt-1">年品質保證</p>
              </div>
              <div>
                <p className="text-4xl font-black text-[#8B4513]">50+</p>
                <p className="text-gray-400 text-xs uppercase tracking-wide mt-1">精選品項</p>
              </div>
              <div>
                <p className="text-4xl font-black text-[#8B4513]">5000+</p>
                <p className="text-gray-400 text-xs uppercase tracking-wide mt-1">滿意顧客</p>
              </div>
            </div>
          </div>
          <div className="relative h-[480px]">
            <div className="absolute top-0 right-0 w-[55%] h-[300px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/bfd807a86a158f44b5983178ab47a35b.jpg"
                alt="專業分切"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-0 left-0 w-[55%] h-[300px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=fresh%20premium%20raw%20meat%20selection%20variety%20cuts%20on%20dark%20slate%20board%20with%20herbs%20rosemary%20garlic%20professional%20food%20photography%20warm%20moody%20lighting&width=500&height=400&seq=about_meat002&orientation=landscape"
                alt="精選肉品"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 bg-[#8B4513] rounded-full flex items-center justify-center z-10">
              <div className="text-center">
                <p className="text-white text-xs font-bold leading-tight">品質</p>
                <p className="text-white text-xs font-bold leading-tight">保證</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
